// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "public/js/" + "about" + "." + "7b44d84d" + ".js";
};